module.exports = __webpack_public_path__ + "img/jms2.f2c13e71.png";